(() => {
  if (!document.documentElement.lang.toLowerCase().startsWith('en')) return;

  const opening = document.currentScript?.dataset.opening;
  if (!opening) return;

  const attached = new WeakSet();
  const selector = 'payment-terms shopify-payment-terms';
  const prefix = /^\s*\d+\s+interest[-\u2010-\u2015]free installments,\s*or\s+(from\s+)$/i;

  function connect(element) {
    if (attached.has(element)) return;
    attached.add(element);

    function bind(attempt = 0) {
      if (!element.isConnected) {
        attached.delete(element);
        return;
      }
      const root = element.shadowRoot;
      if (!root) {
        if (attempt < 100) setTimeout(() => bind(attempt + 1), 100);
        else attached.delete(element);
        return;
      }

      const shorten = () => {
        const content = root.querySelector('#shopify-installments-content');
        const text = content?.firstChild;
        if (text?.nodeType !== Node.TEXT_NODE) return;
        const match = text.nodeValue.match(prefix);
        if (match) text.nodeValue = `${opening} `;
      };

      shorten();
      new MutationObserver(shorten).observe(root, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    bind();
  }

  customElements.whenDefined('shopify-payment-terms').then(() => {
    document.querySelectorAll(selector).forEach(connect);
    new MutationObserver(records => {
      for (const record of records) {
        for (const node of record.addedNodes) {
          if (!(node instanceof Element)) continue;
          if (node.matches(selector)) connect(node);
          node.querySelectorAll(selector).forEach(connect);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  });
})();
